/**
 * Authorization Roles
 */
export const authRoles = {
    admin    : ['admin'],
    guestOnly: ['guest'],
};